__webpack_require__.p = "/InspiroQuote/";